import React, { useEffect, useState, useCallback } from "react";
import { FiClock } from "react-icons/fi";

const ReverseTimerClock = ({ title, targetTime }) => {
  const calculateTimeLeft = useCallback(() => {
    if (!targetTime) return 0;
    const difference = new Date(targetTime).getTime() - Date.now();
    return difference > 0 ? difference : 0;
  }, [targetTime]);

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    setTimeLeft(calculateTimeLeft());
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, [calculateTimeLeft]);

  const formatTime = (ms) => {
    const seconds = Math.floor((ms / 1000) % 60);
    const minutes = Math.floor((ms / 1000 / 60) % 60);
    const hours = Math.floor((ms / 1000 / 60 / 60) % 24);
    const days = Math.floor(ms / 1000 / 60 / 60 / 24);
    return { days, hours, minutes, seconds };
  };

  const LABELS = {
    days: "օր",
    hours: "ժ",
    minutes: "ր",
    seconds: "վ",
  };

  const time = formatTime(timeLeft);

  return (
    <div className="flex flex-col gap-1.5">
      {title && (
        <span className="text-[11px] font-semibold text-slate-500 uppercase tracking-wider flex items-center gap-1">
          <FiClock size={11} className="text-slate-400" />
          {title}
        </span>
      )}
      <div className="flex items-center gap-1.5">
        {Object.entries(time).map(([key, value]) => (
          <div key={key} className="flex flex-col items-center">
            <span className="bg-slate-50 border border-slate-200/90 rounded-lg w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center text-xs sm:text-sm font-bold text-slate-800 font-mono shadow-xs">
              {String(value).padStart(2, "0")}
            </span>
            <span className="text-[9px] font-medium text-slate-400 mt-0.5">
              {LABELS[key]}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReverseTimerClock;
